'use client';
import {Separator as RACSeparator, SeparatorProps} from 'react-aria-components';
import React from 'react';
import './Separator.css';

export function Separator(props: SeparatorProps) {
  return <RACSeparator {...props} />
}